module.exports = __webpack_public_path__ + "img/F5-3A.3cedaf91.png";